import React from "react";
import { withNavBars } from "../../HOCs";
import ParkingGroupingMaster from "./parkingGroupingMaster";

class ParkingGroupingMasterParent extends React.Component {
    render() {
        return <ParkingGroupingMaster  {...this.props} />;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(ParkingGroupingMasterParent, props);
